import React from 'react';
import PropTypes from 'prop-types';
// docs-page-shell
import ReactPageShell from '../../vendor/docs-page-shell/react-page-shell.js';
// dr-ui components
import AnalyticsShell from '@mapbox/dr-ui/analytics-shell';
import PageLayout from '@mapbox/dr-ui/page-layout';
import { buildMeta } from '@mapbox/dr-ui/page-layout/utils';
// site variables
import constants from '../constants';
// batfish modules
import { withLocation } from '@mapbox/batfish/modules/with-location';
// dataSelectors
import navigation from '@mapbox/batfish/data/navigation';
import mbxMeta from '@mapbox/batfish/data/mbx-meta';
import AppropriateImage from './appropriate-image';
import Copiable from '@mapbox/mr-ui/copiable';

class PageShell extends React.PureComponent {
  renderSourceId = () => {
    if (!this.props.frontMatter.mapid) return null;
    return (
      <div>
        <div className="mb18">
          <strong>Source id</strong>:
          <span className="inline-block ml6">
            <Copiable value={this.props.frontMatter.mapid} />
          </span>
        </div>
      </div>
    );
  };
  render() {
    const { location, children, frontMatter } = this.props;
    const meta = buildMeta(frontMatter, location.pathname, navigation);
    const site = meta && meta.subsite ? meta.subsite : constants.SITE;
    return (
      <ReactPageShell
        site={site}
        {...this.props}
        meta={meta}
        darkHeaderText={true}
      >
        <AnalyticsShell
          mbxMetadata={mbxMeta[this.props.location.pathname]}
          location={location}
        >
          <PageLayout
            location={location}
            frontMatter={{
              ...frontMatter,
              ...(frontMatter.overviewHeader && {
                overviewHeader: {
                  ...frontMatter.overviewHeader,
                  image: frontMatter.overviewHeader.image ? (
                    <AppropriateImage
                      imageId={frontMatter.overviewHeader.image}
                      alt=""
                      className="hmax300"
                    />
                  ) : undefined
                }
              })
            }}
            constants={{
              ...constants,
              SITE: site // use subsite name for Feedback
            }}
            navigation={navigation}
            AppropriateImage={AppropriateImage}
          >
            {this.renderSourceId()}
            {children}
          </PageLayout>
        </AnalyticsShell>
      </ReactPageShell>
    );
  }
}

PageShell.propTypes = {
  meta: PropTypes.object,
  frontMatter: PropTypes.object.isRequired,
  children: PropTypes.node,
  location: PropTypes.object.isRequired
};

export default withLocation(PageShell);
